import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  isGameActive: false,
  gameStatus: 'inactive', // active | pending \ inactive
  gameType: 'local',
  gridSize: 3,
  players: 2,
  winCondition: 'First to 3'
}

const getters = {
  getLocalGame(state) {
    if (state.gameType !== 'local') {
      return null
    }

    return {
      isGameActive: state.isGameActive,
      gameStatus: state.gameStatus,
      gridSize: state.gridSize,
      players: state.players,
      winCondition: state.winCondition
    }
  },

  getOnlineGame(state) {
    if (state.gameType !== 'online') {
      return null
    }

    return {
      isGameActive: state.isGameActive,
      gameStatus: state.gameStatus,
      gridSize: state.gridSize,
      players: state.players,
      winCondition: state.winCondition
    }
  }
}

const mutations = {
  SET_IS_GAME_ACTIVE: (state, activeState) => {
    state.isGameActive = activeState
  },

  SET_GAME: (state, payload) => {
    state.gameStatus = payload.gameStatus
    state.gameType = payload.gameType
    state.gridSize = payload.gridSize
    state.players = payload.players
    state.winCondition = payload.winCondition
  }
}

const actions = {

}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/game.module.js